module.exports = {
        srcSet: "/_next/static/images/client-centric-640.645ce7fc.webp"+" 640w"+","+"/_next/static/images/client-centric-828.c6932523.webp"+" 828w"+","+"/_next/static/images/client-centric-950.a32194b6.webp"+" 950w",
        images: [{path: "/_next/static/images/client-centric-640.645ce7fc.webp",width: 640,height: 744},{path: "/_next/static/images/client-centric-828.c6932523.webp",width: 828,height: 963},{path: "/_next/static/images/client-centric-950.a32194b6.webp",width: 950,height: 1105}],
        src: "/_next/static/images/client-centric-950.a32194b6.webp",
        toString: function(){return "/_next/static/images/client-centric-950.a32194b6.webp"},
        
        width: 950,
        height: 1105
      }